import React from 'react';
import { Section } from './Section';
export function Hook() {
  return <Section id="gancho" eyebrow="El gancho" data-id="element-54" data-mp="2b6bty6vgmtqg">
      <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-55" data-mp="2b74tonw04iz3">
        Te han mentido durante años.
      </h2>

      <div className="mt-6 space-y-5 text-lg leading-relaxed text-zinc-400" data-id="element-56" data-mp="2185wc1gos9re">
        <p data-id="element-57" data-mp="21a8kefya3sth">
          Te dijeron que si querías ser fuerte, tenías que olvidarte de correr porque
          “quemarías el músculo”. Te dijeron que si querías ser rápido, tenías que dejar
          las pesas porque te volverías “pesado y lento”.
        </p>
        <p data-id="element-58" data-mp="2g4deyxcg534k">
          La ciencia y los atletas más completos del mundo —
          <span className="text-white" data-id="element-59" data-mp="2k6rtj5931gq1">Navy SEALs</span>,{' '}
          <span className="text-white" data-id="element-60" data-mp="2k4xajwhdfyol">corredores de Hyrox</span> y{' '}
          <span className="text-white" data-id="element-61" data-mp="37vsygiipi9qk">atletas de CrossFit</span>— ya demostraron que
          podés tenerlo todo.
        </p>
        <p className="border-l-2 border-flame-500 pl-5 text-xl font-medium text-white" data-id="element-62" data-mp="3cpfbwcwp2hnf">
          Si estás cansado de ser un “chico de gimnasio” que se agota subiendo las
          escaleras, o un corredor que se siente débil y pequeño... el Entrenamiento
          Híbrido es para vos.
        </p>
      </div>
    </Section>;
}